import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../../../assets/11pets_logo.png';
import clsx from 'clsx';


const useStyles = makeStyles(theme => ({
  wobble: {
    animation: '$wobbleHorBottom 0.8s infinite both'
  },
  '@keyframes wobbleHorBottom': {
    '0%': {},
    '100%': {
      transform: 'translateX(0%)',
      transformOrigin: '50% 50%'
    },
    '15%': {
      transform: 'translateX(-30px) rotate(-6deg)'
    },
    '30%': {
      transform: 'translateX(15px) rotate(6deg)'
    },
    '45%': {
      transform: 'translateX(-15px) rotate(-3.6deg)'
    },
    '60%': {
      transform: 'translateX(9px) rotate(2.4deg)'
    },
    '75%': {
      transform: 'translateX(-6px) rotate(-1.2deg)'
    }
  },
  /**
 * ----------------------------------------
 * animation heartbeat
 * ----------------------------------------
 */
  heartbeat: {
    animation: '$heartbeat 1.5s ease-in-out infinite both',
  },
'@keyframes heartbeat': {
  'from': {
    transform: 'scale(1)',
    transformOrigin: 'center center',
    animationTimingFunction: 'ease-out',
  },
  '10%': {
    WebkitTransform: 'scale(0.91)',
            transform: 'scale(0.91)',
    WebkitAnimationTimingFunction: 'ease-in',
            animationTimingFunction: 'ease-in',
  },
  '17%': {
    WebkitTransform: 'scale(0.98)',
            transform: 'scale(0.98)',
    WebkitAnimationTimingFunction: 'ease-out',
            animationTimingFunction: 'ease-out',
  },
  '33%': {
    WebkitTransform: 'scale(0.87)',
            transform: 'scale(0.87)',
    WebkitAnimationTimingFunction: 'ease-in',
            animationTimingFunction: 'ease-in',
  },
  '45%': {
    WebkitTransform: 'scale(1)',
            transform: 'scale(1)',
    WebkitAnimationTimingFunction: 'ease-out',
            animationTimingFunction: 'ease-out',
  }
}
}));


const LogoSpinner = (props) => {
  const classes = useStyles();
  const { className, animation = 'wobble' } = props;

  return (
    <img className={clsx(className, classes[animation])} src={logo} alt="logo" />
  );
};

LogoSpinner.propTypes = {
  className: PropTypes.string,
  animation: PropTypes.oneOf(['wobble', 'heartbeat'])
}

export default LogoSpinner;